import React from 'react';
import { STYLES, styleLimitMessage } from '../../../vibe/definitions';
import { toggleStyle } from '../../../vibe/selection';

export default function StyleGrid({ styleIds = [], onChange, disabled }) {
  const [message, setMessage] = React.useState('');
  const selectedKey = styleIds.join('|');

  React.useEffect(() => {
    setMessage('');
  }, [selectedKey]);

  const choose = (styleId) => {
    if (disabled) return;
    const result = toggleStyle({ feelId: null, styleIds, flavorIds: [] }, styleId);
    if (result.blocked) {
      setMessage(result.message || styleLimitMessage());
      return;
    }
    setMessage('');
    onChange?.(result.draft.styleIds);
  };

  return (
    <section aria-labelledby="vibe-style-heading">
      <div className="mb-2 flex items-baseline justify-between gap-3">
        <h3 id="vibe-style-heading" className="text-sm font-semibold text-white">Style</h3>
        <p className="text-xs text-white/70">{styleIds.length} / 5 selected</p>
      </div>
      <p className="mb-2 text-xs text-white/70">Choose up to 5</p>
      <div
        role="group"
        aria-label="Styles"
        className="flex flex-wrap gap-2"
      >
        {STYLES.map((style) => {
          const selected = styleIds.includes(style.id);
          return (
            <button
              key={style.id}
              type="button"
              aria-pressed={selected}
              disabled={disabled}
              onClick={() => choose(style.id)}
              className={`inline-flex max-w-full items-center justify-center rounded-full border px-3 py-1.5 text-center text-sm font-medium leading-snug focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-white ${
                selected
                  ? 'border-white bg-white text-gray-950'
                  : 'border-white/15 bg-white/5 text-gray-100'
              }`}
            >
              {selected ? `✓ ${style.label}` : style.label}
            </button>
          );
        })}
      </div>
      {message ? (
        <p role="status" className="mt-2 text-xs text-amber-200">{message}</p>
      ) : null}
    </section>
  );
}
